import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem3,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'



const PrevidenciaPrivadaFormPrevidenciaPrivadaParametros = ( { values, handleChange, handleSubmit } ) => {


    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem12>
                    <CardGridEntradaDados>
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.previdenciaPrivada}
                        >
                            <GridContainer>
                                <GridItem6>
                                    <CheckboxPadrao
                                        name="objPrevidenciaPrivada.simularAportePGBLInferiorMaximoPossivel"
                                        label={LABEL.simularAportePGBLInferiorMaximoPossivel}
                                        checked={values.objPrevidenciaPrivada.simularAportePGBLInferiorMaximoPossivel}
                                        onChange={handleChange}
                                    />
                                </GridItem6>      

                                {values.objPrevidenciaPrivada.simularAportePGBLInferiorMaximoPossivel && (
                                    <>
                                        {!values.objPrevidenciaPrivada.aporteMensalPGBL && (
                                            <GridItem3>
                                                <TextValidatorValor
                                                    name={"objPrevidenciaPrivada.aporteAnualPGBL"}
                                                    label={LABEL.aporteAnualPGBL}
                                                    value={
                                                        values.objPrevidenciaPrivada.aporteAnualPGBL === 0
                                                            ?
                                                                0
                                                            :
                                                                values.objPrevidenciaPrivada.aporteAnualPGBL || ''
                                                    }
                                                    onChange={handleChange}
                                                />
                                            </GridItem3>
                                        )}

                                        {!values.objPrevidenciaPrivada.aporteAnualPGBL && (
                                            <GridItem3>
                                                <TextValidatorValor
                                                    name={"objPrevidenciaPrivada.aporteMensalPGBL"}
                                                    label={LABEL.aporteMensalPGBL}
                                                    value={
                                                        values.objPrevidenciaPrivada.aporteMensalPGBL === 0
                                                            ?
                                                                0
                                                            :
                                                                values.objPrevidenciaPrivada.aporteMensalPGBL || ''
                                                    }
                                                    onChange={handleChange}
                                                />
                                            </GridItem3>
                                        )}
                                    </>
                                )}
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>
                    </CardGridEntradaDados>
                </GridItem12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default PrevidenciaPrivadaFormPrevidenciaPrivadaParametros